<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col">
          <h6>Lista de staff (agentes y supervisores)</h6>
        </div>
        <div class="col">
          <button class="btn bg-gradient-success float-end" @click="$router.push('/staff-create')"> Crear staff</button>
        </div>
      </div>
    </div>
    <div class="card-body px-4">
      <!-- Asignación masiva de IP (solo admin) -->
      <div v-if="$userCan('administrator')" class="border rounded p-3 mb-4">
        <label class="font-weight-bold mb-2 d-block">
          <i class="fas fa-network-wired mr-1"></i>
          Asignar una misma IP a TODO el staff
        </label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="bulkIp"
            placeholder="Ej: 190.25.13.40 (vacío = quitar la IP a todos)"
          />
          <button class="btn bg-gradient-success mb-0" @click="applyBulkIp">
            Aplicar a todos
          </button>
        </div>
        <small class="text-muted d-block mt-1">
          Sobrescribe la IP de todos los agentes y supervisores. Si lo dejás
          vacío, ninguno podrá iniciar sesión hasta que se le asigne una.
        </small>
      </div>

      <!-- Filtros -->
      <div class="row g-2 align-items-center mb-3">
        <div class="col-6 col-md-2">
          <select
            v-model="pagination.limit"
            class="form-control"
            @change="reloadPaginate(1)"
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
        <div class="col-6 col-md-3">
          <select
            v-model="pagination.type"
            class="form-control"
            @change="reloadPaginate(1)"
          >
            <option value="">Todos los roles</option>
            <option value="agent">Agentes</option>
            <option value="supervisor">Supervisores</option>
          </select>
        </div>
        <div class="col-md-7">
          <input
            type="text"
            class="form-control"
            placeholder="Buscar por correo o nombre"
            v-model="pagination.search"
            @keyup="manualSearch"
          />
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-bordered table-sm align-middle">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nombre</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Correo</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Rol</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">IP autorizada</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-end">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key) in arrayStaff" :key="key">
              <td>
                <p class="text-uppercase text-xs font-weight-bold mb-0">{{ item.name }}</p>
              </td>
              <td>
                <p class="text-xs font-weight-bold mb-0">{{ item.email }}</p>
              </td>
              <td>
                <span
                  class="badge text-white text-xs"
                  :class="item.type === 'supervisor' ? 'bg-info' : 'bg-secondary'"
                >
                  {{ roleLabel(item.type) }}
                </span>
              </td>
              <td>
                <span v-if="item.allowed_ip" class="badge bg-success text-white text-xs">
                  {{ item.allowed_ip }}
                </span>
                <span v-else class="badge bg-danger text-white text-xs">
                  SIN ASIGNAR
                </span>
              </td>
              <td>
                <span
                  class="badge text-white text-xs"
                  :class="item.status ? 'bg-success' : 'bg-danger'"
                >
                  {{ item.status ? 'ACTIVO' : 'INACTIVO' }}
                </span>
              </td>
              <td class="text-end">
                <button class="btn btn-outline-danger btn-sm mb-0 me-1" @click="remove(item)">
                  Cambiar estado
                </button>
                <button class="btn btn-success btn-sm mb-0" @click="view(item)">
                  Ver / Editar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-2">
        <p class="text-xs font-weight-bold mb-0">
          Filas totales: {{ pagination.totalRows }}
        </p>
        <v-pagination
          v-model="pagination.page"
          :pages="pagination.pages"
          :range-size="1"
          active-color="#DCEDFF"
          @update:modelValue="reloadPaginate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {get, post} from "@/utils/httpRequest";

export default {
  name: "staff-index",
  data: () => ({
    arrayStaff: [],
    bulkIp: '',
    pagination: {
      searchTimer: null,
      page: 1,
      pages: 0,
      limit: 10,
      search: '',
      type: '',
      totalRows: 0
    }
  }),
  mounted() {
    this.getData()
  },
  methods: {
    roleLabel(type){
      if(type === 'agent') return 'Agente'
      if(type === 'supervisor') return 'Supervisor'
      return type
    },
    async applyBulkIp(){
      this.$swal({
        html: this.bulkIp
          ? `¿Asignar la IP <b>${this.bulkIp}</b> a TODOS los agentes y supervisores?`
          : '¿Quitar la IP a TODOS los agentes y supervisores? No podrán iniciar sesión hasta que se les asigne una.',
        showCancelButton: true,
        confirmButtonText: 'SÍ, aplicar',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (!result.isConfirmed) return
        const {data} = await post('users/assign-ip-bulk', {allowed_ip: this.bulkIp}, true)
        if(data && data.statusCode === 200){
          this.$swal({
            html: `IP actualizada en ${data.updated} usuario(s)`,
            icon: 'success',
            timer: 2500,
            showCancelButton: false,
            showConfirmButton: false,
          });
          await this.getData()
        }else{
          this.$swal({
            html: (data && data.message) || 'No se pudo actualizar la IP',
            icon: 'error',
            timer: 2500,
            showCancelButton: false,
            showConfirmButton: false,
          });
        }
      })
    },
    reloadPaginate(page){
      this.pagination.page = page
      this.getData()
    },
    manualSearch(){
      clearTimeout(this.pagination.searchTimer);
      this.pagination.searchTimer = setTimeout(() => {
        this.reloadPaginate(1)
      }, 1000);
    },
    async getData(){
      const {data} = await get(`users/find-all-staff?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${this.pagination.search}&type=${this.pagination.type}`, null, true)
      this.arrayStaff = data.docs
      this.pagination.totalRows = data.count
      this.pagination.page = data.page
      this.pagination.pages = data.pages
    },
    async remove(item){
      this.$swal({
        html: '¿Estás seguro?',
        showCancelButton: true,
        confirmButtonText: 'SÍ',
        cancelButtonText: `NO`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await post("users/remove", {_id: item._id}, true)
          this.$swal({
            html: 'Proceso realizado con éxito',
            icon: 'success',
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
          await this.getData()
        }
      })
    },
    view(item){
      this.$router.push({name: 'staff-view', query: {id: item._id}})
    }
  }
}
</script>

<style scoped lang="scss">
.gap-2 {
  gap: 0.5rem;
}
</style>
